module.exports = __webpack_public_path__ + "img/zoom_in.84f1a870.svg";